import { useMutation } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";

export const useBulkCheckout = () => {
  return useMutation({
    mutationFn: (data: { bulk_request: any }) =>
      apiClient.post(Routes.BULK_CHECKOUT, data),
  });
};
